/**
 * Roles Reducers
 */
 import {
    ALL_ROLES,
    ADD_ROLE,
    ROLE_ACTION,
    EDIT_ROLE,
    STATUS_ROLE,
    DELETE_ROLE
} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    rolelists:[],
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case ROLE_ACTION:
            return { ...state, loading: true };

        case ALL_ROLES:
            return { ...state, loading: false, rolelists: action.payload };  
            
        case ADD_ROLE:
            return { ...state, loading: false }; 
        
        case EDIT_ROLE:
            return { ...state, loading: false };  
        
        case STATUS_ROLE:
            return { ...state, loading: false };    
        
        case DELETE_ROLE:
            return { ...state, loading: false };      

        default: return { ...state };
    }
}